import { PageLayout } from 'app/views/components/layout/page-layout'
import HolidayCalendarsHeader from './holiday-calendars-header'

export default function HolidayCalendarsPage() {
    return (
        <PageLayout>
            <HolidayCalendarsHeader />
        </PageLayout>
    )
}